<script lang="ts" setup>
import { PageHero } from '~/components';
import { SupportRow, SupportShell } from '~/components/support';

definePageMeta({ layout: 'default' });

useHead({ title: 'Support' });
useSeoMeta({
  description:
    'Get help with VoteWise — browse help topics, contact us or report a problem.',
  ogTitle: 'Support | VoteWise',
  ogDescription:
    'Get help with VoteWise — browse help topics, contact us or report a problem.',
});
</script>

<template>
  <div class="support-page">
    <PageHero constrained max-width="max-w-[1200px]">
      <div class="support-page__panel" data-testid="support-page">
        <SupportShell heading="Help Centre" flush-on-mobile>
          <SupportRow
            label="Contact us"
            to="/contact-us"
            testid="support-contact-us"
          />

          <SupportRow
            label="Help Us Improve"
            to="/report-a-problem"
            testid="support-report-a-problem"
          />
        </SupportShell>
      </div>
    </PageHero>
  </div>
</template>

<style scoped lang="scss">
.support-page {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  min-height: calc(100vh - var(--header-height));

  &__panel {
    display: flex;
    flex-direction: column;
  }
}
</style>
